import { Component, Watch } from 'vue-property-decorator';
import { Button } from 'streamlabs-beaker';
import Canvas from './Canvas.vue';
import VerticalCanvas from './VerticalCanvas.vue';
import LayerMobile from './LayerMobile.vue';
import { ECanvasSidebar, EComponentType, EEditorType } from '@/helpers/editor';
import TextSettings from './settings/TextSettings.vue';
import WebcamSettings from './settings/WebcamSettings.vue';
import ImageSettings from './settings/ImageSettings.vue';
import SLWidgetSettings from './settings/SLWidgetSettings.vue';
import CustomComponentSettings from './settings/CustomComponentSettings.vue';
import VideoSettings from './settings/VideoSettings.vue';
import Editor from './Editor.vue';
import NewComponentModalMobile from './modals/NewComponentModalMobile.vue';
import Tooltip from '@/components/utils/Tooltip.vue';
import ThemeLibraryMobileModal from '@/components/editor/modals/ThemeLibraryMobileModal.vue';
import StreamLabelSettings from './settings/StreamLabelSettings.vue';
import StreamLabelModal from '@/components/editor/modals/StreamLabelModal.vue';
import GameCaptureSettings from './settings/GameCaptureSettings.vue';

@Component({
  components: {
    Canvas,
    VerticalCanvas,
    LayerMobile,
    NewComponentModalMobile,
    Tooltip,
    SButton: Button,
    ThemeLibraryMobileModal,
    StreamLabelModal,
  },
})
export default class EditorMobile extends Editor {
  mode: EEditorType = EEditorType.horizontal;
  tooltipDismissed: boolean = false;

  get shouldShowLayerSidebar(): boolean {
    return this.showSidebar && this.sidebarType === ECanvasSidebar.layer;
  }

  get shouldShowSettingsSidebar(): boolean {
    return this.showSidebar && this.sidebarType === ECanvasSidebar.settings;
  }

  get settingsTemplate() {
    if (!this.selectedComponent) return null;

    switch (this.selectedComponent.type) {
      case EComponentType.text:
        return TextSettings;

      case EComponentType.image:
        return ImageSettings;

      case EComponentType.video:
        return VideoSettings;

      case EComponentType.alertBox:
      case EComponentType.eventList:
      case EComponentType.chat:
        return SLWidgetSettings;

      case EComponentType.customComponent:
        return CustomComponentSettings;
      case EComponentType.webcam:
        return WebcamSettings;
      case EComponentType.streamLabel:
        return StreamLabelSettings;
      case EComponentType.gameCapture:
        return GameCaptureSettings;

      default:
        return null;
    }
  }

  get canUndoComponentUpdate() {
    return this.editorModule.componentUpdateUndoList.length;
  }

  get canRedoComponentUpdate() {
    return this.editorModule.componentUpdateRedoList.length;
  }

  get oppositeEditorType(): EEditorType {
    return this.mode === EEditorType.horizontal ? EEditorType.vertical : EEditorType.horizontal;
  }

  get editButtonIconClass(): string[] {
    return this.oppositeEditorType === EEditorType.horizontal ? ['icon-desktop'] : ['icon-phone-case'];
  }

  get isVertical(): boolean {
    return this.mode === EEditorType.vertical;
  }

  async closeTooltip() {
    this.tooltipDismissed = true;
  }

  toggleEditorType() {
    this.mode = this.oppositeEditorType;
  }

  navigateToScenes() {
    this.$router.back();
  }

  @Watch('selectedComponent')
  handler() {
    if (!this.selectedComponent && this.sidebarType === ECanvasSidebar.settings) this.showSidebar = false;
  }
}
